import api from "./api";

const promotionService = {
    // GET /api/promotion/class?academicYear=&course=&yearNumber=
    getClass: (params) => api.get("/promotion/class", { params }),
    // PUT /api/promotion/bulk-save
    bulkSave: (updates) => api.put("/promotion/bulk-save", { updates }),
};

export default promotionService;